import PropTypes from "prop-types";
import React from "react";
import { Button } from "cxa-components";
import { reduxForm } from "redux-form";
import { DateField, StringField, SelectField } from "cxa-form-field";
import SurveyDocumentUpload from "./SurveyDocumentUpload";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { ErrorMessage } from "../../common/ErrorMessage";

let pFields = [];

const validate = values => {
  const errors = {};
  pFields && pFields.forEach(({ questionId = "", isMandatory, questionDataType }) => {
    const qId = questionId.toLowerCase();
    if (isMandatory) {
      if (questionDataType === "UploadDocument") {
        if (!values[qId] || !values[qId][0]) {
          errors[qId] = "Required";
        }
      } else if (!(values[qId] && typeof values[qId] === 'string' && values[qId].trim())) {
        errors[qId] = "Required";
      }
    }
  });

  return errors;
};
const SurveyForm = (props) => {
  const {
    handleSubmit,
    fields,
    description,
    cancel,
    err,
    invalid,
    intl,
  } = props
  pFields = fields;
  let index = 0;
  return (
    <form onSubmit={handleSubmit}>
      <article className="card">
        {description && (
          <header>
            <h2>{description}</h2>
          </header>
        )}
        <section>
          {fields.map(
            ({
              description,
              dataTypeLookup = [],
              isMandatory,
              questionDataType,
              questionId,
              questionText,
            }) => {
              let field;
              const label = `${questionId} ${questionText} ${description}`;
              const qId = questionId.toLowerCase();
              if (questionDataType === "DropDown" || questionDataType === "EligibleDependants") {
                field = (
                  <div className="cxa_survey">
                    <SelectField
                      label={label}
                      key={qId}
                      name={qId}
                      items={dataTypeLookup.map(item => ({
                        value: item,
                        label: item,
                      }))}
                    />
                  </div>
                );
              } else if (questionDataType === "Date") {
                field = <DateField label={label} name={qId} required={isMandatory} />;
              } else if (questionDataType === "UploadDocument") {
                field = <SurveyDocumentUpload name={qId} label={label} required={isMandatory} />;
              } else {
                field = <StringField name={qId} label={label} required={isMandatory} />;
              }
              return <div key={index++}>{field}</div>;
            }
          )}
        </section>
      {err && (
        <ErrorMessage error={err.response.body} intl={intl} />
      )}
      </article>
      <p>
        <Button primary type="submit" disabled={invalid}>
          {intl.formatMessage(messages.submitTextDescription)}
        </Button>
        <Button type="button" secondary onClick={cancel}>
          {intl.formatMessage(messages.cancelTextDescription)}
        </Button>
      </p>
    </form>
  );
};

SurveyForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fields: PropTypes.array,
  description: PropTypes.string,
  cancel: PropTypes.func,
  err: PropTypes.object,
  invalid: PropTypes.bool,
  employeeKey: PropTypes.number,
  update: PropTypes.func,
  intl: intlShape.isRequired,
};

export default injectIntl(
  reduxForm({
    form: "surveyForm",
    validate,
  })(SurveyForm)
);



// WEBPACK FOOTER //
// ./components/employee/benefits/SurveyForm.js